/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import i18next from "i18next";
import { WarningOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";

const AjaxSelect = ({
  item,
  tooltip,
  input,
  inputName,
  withPlaceholder = true,
  data,
  linkingData,
  ajaxOptions,
}) => {
  const [option, setOption] = useState(null);
  useEffect(() => {
    if (input.dataLink) {
      // eslint-disable-next-line no-unused-vars
      const [a, b, mapper] = input.call.split('::');
      const linkigD = linkingData ? linkingData[input.dataLink.formNamespace] : {};
      let inputData;
      if (inputName !== 'parent') {
        inputData = linkigD
          ? linkigD[item ? item[inputName] : data[inputName]]
          : null;
      } else {
        inputData = item ? item : data;
      }
      setOption(Object.keys(JSON.parse(mapper))
        .reduce((opt, key) => {
          opt[key] = inputData ? inputData[JSON.parse(mapper)[key]] : null;
          return opt;
        }, {}));
    } else {
      setOption(ajaxOptions.find(opt =>
        opt.value === (item ? item[inputName] : data[inputName])));
    }
  }, []);

  const _v = option && option.label
    ? option.label
    : (
      withPlaceholder ? <span className="text-muted font-italic">
        <WarningOutlined />
        {i18next.t('Unanswered')}
      </span>
        : ''
    )

  if (tooltip) {
    return <Tooltip title={_v}>{_v}</Tooltip>
  }

  return _v;
};

export default AjaxSelect;
